<template>
  <div class="s-download-progress" v-if="getDownloadProgress.length > 0">
    <h6 class="u-margin-bottom-xsmall">
      <i class="icofont-download"></i> {{ $t("common.downloading") }}
    </h6>
    <hr />
    <ul class="c-list">
      <li
        class="c-list__item"
        v-for="(item, i) in getDownloadProgress"
        :key="i"
      >
        <div class="c-list__item__title u-color-primary">
          <i class="icofont-file-zip"></i> {{ item.folderPath }}
        </div>
        <div class="c-list__item__progress u-text-align-center">
          <div><i class="icofont-download"></i></div>
          <strong>{{ item.percentage.toFixed(2) }}% </strong>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    getActiveUser() {
      return this.$store.getters["getActiveUser"];
    },
    ...mapGetters(["getDownloadProgress"]),
  },
};
</script>

<style></style>
